module.exports = __webpack_public_path__ + "img/product-shot_02_loading.aa4864dc.jpg";